/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import { ContentCard } from '../../components'
import AccordionItem from '../../components/AccordionItem/AccordionItem'
import { useBeforeaftercontent } from '../../hooks'
import useMediaQuery from '../../hooks/useMediaQuery'
import { SectionContainer } from '../../layouts'
import { ContentParser, hasNulls } from '../../utils/helpers'
import {
  contentCardsContainer,
  extraContentCardStyle,
  sectionContainer,
} from './BeforeAfterSection.module.css'

const BeforeAfterSection = ({ isSurgery, lang, slice }) => {
  const data = useBeforeaftercontent()
  const isDesktop = useMediaQuery('(min-width: 768px)')

  if (!isSurgery) {
    return null
  }

  const { containerwidth, includedefaultdata } = slice
  if (!includedefaultdata) {
    return null
  }
  const localisedData = data.filter((item) => item.language.slug === lang)
  const { beforeaftercontent } = localisedData[0]
  const contentCards = ContentParser(beforeaftercontent, 'contentcard').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  const customContent = ContentParser(slice, 'beforeaftercontent').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  const { heading } = beforeaftercontent

  return (
    <SectionContainer
      containerwidth={containerwidth}
      extraClassName={sectionContainer}
      heading={heading}
      withHeader
    >
      <div className={contentCardsContainer}>
        {contentCards.length > 0 &&
          contentCards.map((card, index) => {
            return isDesktop ? (
              <ContentCard
                {...card}
                key={index}
                customContent={customContent[index]}
                extraContentCardStyle={extraContentCardStyle}
                readmoreCta
              />
            ) : (
              <AccordionItem
                key={index}
                active={index === 0}
                item={{
                  title: card.title,
                  image: card.image,
                  content: customContent ? customContent[index] : card.content,
                  kicker: card.kicker,
                }}
                withKicker
                withTitle
              />
            )
          })}
      </div>
    </SectionContainer>
  )
}

export default BeforeAfterSection
